import { Helmet } from 'react-helmet';

export function Fonts() {
  return (
    <Helmet>
      <link
        as="font"
        crossOrigin="anonymous"
        href="/fonts/editorial/PPEditorialNew-Regular.woff2"
        rel="preload"
        type="font/woff2"
      />
      <style type="text/css">
        {[300, 400, 500, 600, 700]
          .map(
            weight => `
              @font-face {
                font-family: 'PP Editorial Old';
                src:
                  url('/fonts/editorial/PPEditorialNew-Regular.woff2') format('woff2'),
                  url('/fonts/editorial/PPEditorialNew-Regular.woff') format('woff');
                font-style: normal;
                font-weight: ${weight};
                font-display: swap;
              }
          `
          )
          .join('\n')}
      </style>
    </Helmet>
  );
}
